import { render, staticRenderFns } from "./ExamAnalysis.vue?vue&type=template&id=dc515c1a&scoped=true"
import script from "./ExamAnalysis.vue?vue&type=script&lang=js"
export * from "./ExamAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ExamAnalysis.vue?vue&type=style&index=0&id=dc515c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc515c1a",
  null
  
)

export default component.exports